import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function ScrollColor({ node }) {
	const $barbaContainer = document.getElementById('barba-container');
	const $elements = node.querySelectorAll('[data-colors]');
	let initial = true;

	// If no data, such as 404
	if (!$barbaContainer.dataset.theme) return () => {};

	let currentColors = JSON.parse($barbaContainer.dataset.theme) ?? {
		bg: '#ffffff',
		text: '#181F1F',
		bgClass: 'bg-white',
		textClass: 'text-ink',
	};

	function updateColors({ bg, text, bgClass, textClass }, initial = false) {
		console.log(
			'updateColors',
			{ bg, text, bgClass, textClass },
			performance.now()
		);
		// if (bg === currentColors.bg && text === currentColors.text) return;

		document.body.dataset.textColor = textClass;
		document.body.dataset.background = bgClass;

		if (initial) {
			document.body.style.backgroundColor = `${bg}`;
			document.body.style.color =
				text === 'text-white' || text === '#ffffff' ? '#ffffff' : '#181F1F';
			initial = false;
		} else {
			console.log('document body ', { bg, text, bgClass, textClass });

			gsap.to(document.body, {
				backgroundColor: bg,
				color:
					text === 'text-white' || text === '#ffffff' ? '#ffffff' : '#181F1F',
				duration: 0.3,
				overwrite: true,
				ease: 'linear',
			});
		}

		currentColors = { bg, text, bgClass, textClass };
	}

	// If only one element (the footer)
	if ($elements.length === 1) return updateColors(currentColors);

	function observeElements(elements) {
		elements.forEach(element => {
			ScrollTrigger.create({
				trigger: element,
				onEnter: () => {
					console.log('onEnter', performance.now());
					try {
						const colors = JSON.parse(
							element.dataset.colors || element.dataset.colorsDynamic || '{}'
						);

						updateColors(colors);
					} catch (e) {
						console.warn('Invalid data-colors JSON:', element.dataset.colors);
					}
				},
				onEnterBack: () => {
					console.log('onEnterBack', performance.now());
					try {
						const colors = JSON.parse(
							element.dataset.colors || element.dataset.colorsDynamic || '{}'
						);
						updateColors(colors);
					} catch (e) {
						console.warn('Invalid data-colors JSON:', element.dataset.colors);
					}
				},
				start: 'top center',
				end: 'bottom center',
				once: false,
			});
		});
	}

	observeElements(node.querySelectorAll('[data-colors]'));

	ScrollTrigger.refresh();

	return () => {
		// kill all ScrollTrigger instances
		ScrollTrigger.getAll().forEach(trigger => trigger.kill());
		ScrollTrigger.refresh();
	};
}

export default ScrollColor;
